import { useQuery } from "@apollo/client";
import { usePrimarySection } from "@/hooks/usePrimarySection";
import { ChangeRequestStatus, type Node } from "@/pages/sections/[sectionId]/change-requests/queries";
import { DASHBOARD_PENDING_CHANGE_REQUEST_LIMIT, DASHBOARD_PENDING_CHANGE_REQUESTS_QUERY } from "../queries";
import { isInitialQueryLoading } from "../_utils/isInitialQueryLoading";

export default function usePendingChangeRequests() {
  const { primarySectionId, loading: primarySectionLoading } = usePrimarySection();

  const { data, previousData, loading, networkStatus, error } = useQuery(DASHBOARD_PENDING_CHANGE_REQUESTS_QUERY, {
    variables: {
      sectionId: primarySectionId ?? "",
      first: DASHBOARD_PENDING_CHANGE_REQUEST_LIMIT,
      stage: ChangeRequestStatus.PENDING
    },
    skip: !primarySectionId,
    fetchPolicy: "cache-and-network"
  });

  const resolvedData = data ?? previousData;
  const canManageChangeRequests = resolvedData?.section.permissions.manageChangeRequests ?? false;
  const changeRequests = (resolvedData?.section.changeRequests.nodes ?? []).filter(Boolean) as Node[];
  const totalPendingCount = resolvedData?.section.changeRequests.totalCount ?? 0;
  const permissionProbeLoading = !!primarySectionId && !primarySectionLoading && resolvedData === undefined;
  const queryActive = !!primarySectionId;

  return {
    sectionId: primarySectionId,
    changeRequests,
    totalPendingCount,
    canManageChangeRequests,
    permissionProbeLoading,
    loading:
      primarySectionLoading ||
      (queryActive &&
        isInitialQueryLoading({
          loading,
          networkStatus,
          itemCount: changeRequests.length,
          hasData: resolvedData !== undefined,
          error
        }))
  };
}
